<div class="vs-container">
  <div class="vs-area vs-area-views p-8">
    <div class="vertical-button-toggle">
      <div>
        <mat-button-toggle-group
        (change)="onViewSplitChange($event.value)"
        vertical="true"
        class="vertical-button-toggle"
        >
        <mat-button-toggle
        *ngFor="let vs of viewSplits"
        class="button-view"
        [value]="vs.id"
        [hidden]="vs.hide()"
        >
        <img [src]="vs.symbol" alt="vs.players" [title]="vs.players" />
      </mat-button-toggle>
      
        </mat-button-toggle-group>
      </div>
      <div class="action-buttons">
        <mat-icon class="action-button" (click)="showAddPreset()">add_circle</mat-icon>
        <mat-icon class="action-button" (click)="showUpdatePreset()" *ngIf="currentPresetId">save</mat-icon>
        <mat-icon class="action-button" (click)="clearSplitScreen()">clear</mat-icon>
      </div>
  </div>
</div>
<div class="vs-area vs-area-videos">
  <div class="videos-container" [ngClass]="['layout-' + currentViewSplit.id]">
    <div
    *ngFor="let slot of _videoSplitService.slots; let i = index"
    class="video-player"
    [ngClass]="getSlotId(i + 1)"
        [id]="getSlotId(i + 1)"
        cdkDropList
        [cdkDropListData]="slot.data ? [slot.data] : []"
        [cdkDropListConnectedTo]="_videoSplitService.connectedDropLists"
        (cdkDropListDropped)="onDropped($event, i)"
      >
        <show-video-player
          [playerId]="i + 1"
          [sensor]="_videoSplitService.sensors[i]"
          [ngClass]="isDragging ? 'allow-dropping' : 'allow-video-control'"
          *ngIf="isPlayerShown(i)"
        ></show-video-player>
      </div>
    </div>
  </div>
</div>
